<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteSaleConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("sales.delivery_time_placeholder")' :danger="!$v.form.delivery_time" :danger-text="$t('validation.required', { attribute: $t('sales.delivery_time') })" v-model="form.delivery_time" :label='$t("sales.delivery_time")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-lg=12)
        b-form-group
          vm-input(:danger="!$v.form.exchange_rate" :danger-text="$t('validation.required', { attribute: $t('sales.delivery_time') })" v-model="form.exchange_rate" :label='$t("sales.exchange_rate")' type="Number")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="users" :label="$t('strings.user')" :serializer="item => item.name" :data="salesCatalog.users" :placeholder="$t('sales.seller_id_placeholder')" :danger="!$v.form.created_by_id.numeric" :danger-text="$t('validation.required', { attribute: $t('sales.created_by_id') })" v-model="form.created_by_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :defaultValue="form.created_by && form.created_by.name ? form.created_by.name : ''")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-typeahead(url="quotations" :label="$t('strings.quotation')" :serializer="item => item.folio" :data="salesCatalog.quotations" :placeholder="$t('sales.quotation_id_placeholder')" v-model="form.quotation_id" :filter="query => `?param=${query},folio`" @input-change="autoCompleteFunc" )
          template(slot-scope="{data}")
            vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.data.folio" v-for="item,index in data")
        b-form-group
          label {{$t("purchase_orders.comments")}}
          vm-textarea(v-model="form.comments" counter="400")
    //-
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-select(url="payment_methods" column="name" :placeholder='$t("sales.payment_method_id_placeholder")' :danger="!$v.form.payment_method_id.numeric" :danger-text="'Payment Method ID is required.'" v-model="form.payment_method_id" :label='$t("sales.payment_method_id")' @input-change="autoCompleteFunc")
              vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in salesCatalog.payment_methods")
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalSales',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'salesCatalog']),
    getTitle () {
      return this.isAdd ? this.$t('sales.add') : this.$t('sales.edit')
    }
  },
  validations: {
    form: {
      delivery_time: {
        required
      },
      total: {
        required
      },
      customer_id: {
        required,
        numeric
      },
      currency_id: {
        required,
        numeric
      },
      created_by_id: {
        required,
        numeric
      },
      quotation_id: {
        required,
        numeric
      },
      payment_method_id: {
        required,
        numeric
      },
      exchange_rate: {
        required
      }
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addSale',
      'editSale',
      'deleteSale',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addSale(this.form) : this.editSale(this.form)
    },
    async deleteSaleConfirm (sale) {
      let t = this
      this.auxDeleteSale = () => {
        t.deleteSale(sale)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          attribute: this.$t(sale.id)
        }),
        accept: this.auxDeleteSale
      })
    },
    async getCatalog () {
      Object.keys(this.salesCatalog).forEach(e =>
        this.loadCatalog({ url: e, filter: '' })
      )
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
